import React, { useEffect } from 'react'
import Dialog from '@material-ui/core/Dialog'
import Button from '@material-ui/core/Button'
import { ModalBody, Title, Body, Footer } from './styled'
import CircularProgress from '@material-ui/core/CircularProgress'
const KickBox = props => {
  const { isOpen, onClose } = props
  return (
    <Dialog open={isOpen}>
      <ModalBody>
        <Body>
          <CircularProgress />
        </Body>
      </ModalBody>
    </Dialog>
  )
}

export default KickBox
